// Import required classes from Firebase
import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { collection, onSnapshot } from 'firebase/firestore';
import { getAuth, onAuthStateChanged, signInAnonymously, connectAuthEmulator } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getAnalytics } from "firebase/analytics";


// Firebase config object
const firebaseConfig = {
  apiKey: "AIzaSyBgAV8m_0KX7uwx4eAj-3BdyHpwlDb2gAg",
  authDomain: "playful-ce174.firebaseapp.com",
  projectId: "playful-ce174",
  storageBucket: "playful-ce174.appspot.com",
  messagingSenderId: "45397579591",
  appId: "1:45397579591:web:d5b78ab88ccdde73511e62",
  measurementId: "G-8VMZEJBT0J"
};

const app = initializeApp(firebaseConfig); 

// Initialize Firestore
const db = getFirestore(app);

const analytics = getAnalytics(app);

// Connect to Firestore Emulator
if (location.hostname === "localhost") {
  connectFirestoreEmulator(db, "localhost", 8081); // Default port for Firestore emulator
}

// Initialize Authentication
const auth = getAuth();
if (location.hostname === "localhost") {
  connectAuthEmulator(auth, "http://localhost:9099");
}

// Initialize Functions
const functions = getFunctions(app);

// Connect to Functions Emulator
if (location.hostname === "localhost") {
  connectFunctionsEmulator(functions, "localhost", 5001); // Your Functions emulator is running on port 5001
}

// Use the new methods, e.g.,
onAuthStateChanged(auth, user => {
  // Handle user state
 // console.log("Auth onAuthStateChanged");
 // console.log(auth);
 // console.log(user);
 // console.log("Auth onAuthStateChanged finished");
});

function logout() {
  signOut(auth);
}

export { app, db, auth, functions, analytics };

//export default app;

/*
// Initialize Firebase
const app = initializeApp(firebaseConfig); 
export default app;

// Initialize Firestore
const db = getFirestore(app);

export { db };
*/


//export const analytics = getAnalytics(app);

// boilerplate from firebase:
/*
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { collection, getDocs } from "firebase/firestore"; 

import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBgAV8m_0KX7uwx4eAj-3BdyHpwlDb2gAg",
  authDomain: "playful-ce174.firebaseapp.com",
  projectId: "playful-ce174",
  storageBucket: "playful-ce174.appspot.com",
  messagingSenderId: "45397579591",
  appId: "1:45397579591:web:d5b78ab88ccdde73511e62",
  measurementId: "G-8VMZEJBT0J"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
const analytics = getAnalytics(app);
*/
